<template>
  <div class="zones-filial-select">
    <v-select
      :value="value"
      :items="items"
      item-text="name"
      item-value="id"
      label="Филиал"
      hide-details="auto"
      background-color="#ffffff"
      height="60"
      flat
      solo
      :menu-props="{ contentClass: 'zones-filial-select-menu', maxHeight: '90vh' }"
      no-data-text="Ничего не найдено"
      @change="$emit('input', $event)"
    >
      <template v-slot:prepend-item>
        <v-list-item class="zones-filial-search">
          <v-list-item-content>
            <v-text-field
              v-model="search"
              placeholder="Поиск..."
              filled
              dense
            >
              <template v-slot:append>
                <font-awesome-icon color="#FF9100" icon="search" />
              </template>
            </v-text-field>
          </v-list-item-content>
        </v-list-item>
      </template>

      <template v-slot:selection="{ item }">
        <div v-if="item.id === 'all'" class="zones-all-item">
          <v-icon color="#ff9100" size="20">
            mdi-map-marker
          </v-icon>
          <span>Вся карта сети</span>
        </div>
        <global-filial-select-item v-else :item="item" :is-select-value="true" />
      </template>

      <template v-slot:item="{ item, attrs }">
        <div v-if="item.id === 'all'" class="zones-all-item">
          <v-icon color="#ff9100" size="20">
            mdi-map-marker
          </v-icon>
          <span>Вся карта сети</span>
        </div>
        <global-filial-select-item
          v-else
          :item="item"
          :selected="attrs['aria-selected'] === 'true'"
          :is-list-item="true"
        />
      </template>
    </v-select>
  </div>
</template>

<script>
  import GlobalFilialSelectItem from '@/components/header/GlobalFilialSelectItem'

  export default {
    name: 'FilialSelect',
    components: { GlobalFilialSelectItem },
    props: {
      value: { type: [String, Number], default: 'all' },
      // филиалы приходят из зон доставки (см. DeliveryZonesPage.buildFilialsFromZones),
      // а не из глобального списка branches — тот может быть неполным из-за прав доступа
      filials: { type: Array, default: () => [] },
    },
    data: () => ({ search: '' }),
    computed: {
      items () {
        const q = (this.search || '').toLowerCase()
        const filtered = (this.filials || []).filter(
          (f) => (f.name || '').toLowerCase().indexOf(q) > -1,
        )
        return [{ id: 'all', name: 'Вся карта сети' }, ...filtered]
      },
    },
  }
</script>

<style lang="less">
  .zones-all-item {
    display: flex;
    align-items: center;
    gap: 8px;
  }
  // closed select input: white bg + border like the chips below + radius 10
  .zones-filial-select .v-input__slot {
    border: 2px solid #e0e3e7 !important;
    border-radius: 10px !important;
    box-shadow: none !important;
  }
  .zones-filial-select-menu {
    box-shadow: 0px 4px 34px 0px rgba(0, 0, 0, 0.3);
    border-radius: 10px;
  }
  .zones-filial-search {
    margin-top: -8px;
    position: sticky;
    top: 0;
    background: #fff;
    z-index: 10;

    .v-text-field {
      & > .v-input__control > .v-input__slot {
        &:after,
        &:before {
          display: none;
        }
      }
    }
    .v-input {
      border-radius: 5px;
      input {
        font-size: 14px;
      }
      &__append-inner {
        margin: auto 0 !important;
      }
    }
    .v-text-field__details {
      display: none;
    }
  }
</style>
